import { Radio, RadioProps } from "@mui/material";
import { styled } from "@mui/material/styles";

export default styled(Radio)<RadioProps>(({ theme }) => {
  return {
    "&.MuiRadio-root": {
      margin: theme.spacing(0.25),
      height: 18,
      width: 18,
      color: theme.palette.secondary.main,
      borderWidth: 1,
      borderStyle: "solid",
      padding: 3,
      borderColor: theme.palette.secondary.main,

      "&.MuiRadio-root::after": {
        content: "''",
        backgroundColor: "transparent",
        width: 10,
        height: 10,
        borderRadius: "50%",
      },

      "&.Mui-disabled": {
        borderColor: theme.palette.primary.dark,
      },

      "&.Mui-checked::after": {
        backgroundColor: theme.palette.secondary.main,
      },

      "&.Mui-checked.Mui-disabled::after": {
        backgroundColor: theme.palette.primary.dark,
      },

      "& .PrivateSwitchBase-input": {
        width: 16,
        height: 16,
      },

      "& .MuiSvgIcon-root": {
        display: "none",
      },
    },
  };
});
